import { render, staticRenderFns } from "./SelectableItemV2.vue?vue&type=template&id=97b4a816&scoped=true"
import script from "./SelectableItemV2.vue?vue&type=script&lang=js"
export * from "./SelectableItemV2.vue?vue&type=script&lang=js"
import style0 from "./SelectableItemV2.vue?vue&type=style&index=0&id=97b4a816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4a816",
  null
  
)

export default component.exports